//utils/qrHelpers.ts
export function generateMarginTexts(contract: string, tokenId: number, networkId: number): string[] {
    return [
      contract.substring(28).toLocaleUpperCase(),
      `${tokenId} - ${networkId}`,
      'SIGALMARK™',
      'CERTIFICATE',
      contract.substring(0, 14).toLocaleUpperCase(),
      contract.substring(14, 28).toLocaleUpperCase(),
    ];
  }

//   //utils/qrHelpers.ts
// export function generateMarginTexts(contract: string, tokenId: number, networkId: number): string[] {
//   return [
//     '',
//     '',
//     '',
//     '',
//     '',
//     '',
//   ];
// }
  